import * as React from 'react'
import { cn } from '../../utils'

export interface KbdProps extends React.HTMLAttributes<HTMLElement> {
  children: React.ReactNode
}

const Kbd = React.forwardRef<HTMLElement, KbdProps>(({ className, children, ...props }, ref) => {
  return (
    <kbd
      ref={ref}
      className={cn(
        'pointer-events-none inline-flex h-5 select-none items-center gap-1 rounded border bg-muted px-1.5 font-mono text-2xs font-medium text-muted-foreground opacity-100',
        className
      )}
      {...props}
    >
      {children}
    </kbd>
  )
})
Kbd.displayName = 'Kbd'

export { Kbd }
